import { useState, useEffect } from "react";
import GetUserInfoService from "../service/GetUserInfoService";

let cachedOrderCount = null;
let cachedUsername = null;
let pendingRequest = null;
let cacheTimestamp = null;
const CACHE_DURATION = 60000;

const useOrderCount = () => {
  const [orderCount, setOrderCount] = useState(cachedOrderCount);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getUserInfoService = new GetUserInfoService();

  useEffect(() => {
    const username = localStorage.getItem("__extraconomy_username");
    const token = localStorage.getItem("__extraconomy_token");

    if (!token || !username) {
      setOrderCount(null);
      cachedOrderCount = null;
      cachedUsername = null;
      cacheTimestamp = null;
      return;
    }

    const now = Date.now();
    const isCacheValid =
      cachedOrderCount !== null &&
      cachedUsername === username &&
      cacheTimestamp &&
      (now - cacheTimestamp) < CACHE_DURATION;

    if (isCacheValid) {
      setOrderCount(cachedOrderCount);
      return;
    }

    const fetchOrderCount = async () => {
      if (pendingRequest) {
        try {
          const result = await pendingRequest;
          setOrderCount(result);
        } catch (err) {
          setError(err);
        }
        return;
      }

      setLoading(true);
      setError(null);

      pendingRequest = getUserInfoService
        .getUserOrderCount(token, username)
        .then((res) => {
          if (res.messageCode === 200001) {
            cachedOrderCount = res.result;
            cachedUsername = username;
            cacheTimestamp = Date.now();
            setOrderCount(res.result);
            return res.result;
          } else {
            throw new Error(`Error fetching order count: ${res.messageCode}`);
          }
        })
        .catch((err) => {
          setError(err);
          throw err;
        })
        .finally(() => {
          setLoading(false);
          pendingRequest = null;
        });

      try {
        await pendingRequest;
      } catch (err) {
        console.error("Error in useOrderCount:", err);
      }
    };

    fetchOrderCount();
  }, []);

  return { orderCount, loading, error };
};

export const clearOrderCountCache = () => {
  cachedOrderCount = null;
  cachedUsername = null;
  pendingRequest = null;
  cacheTimestamp = null;
};

export const incrementOrderCountCache = () => {
  if (cachedOrderCount !== null) {
    cachedOrderCount += 1;
    cacheTimestamp = Date.now();
  }
};

export default useOrderCount;

